<template>
    <div>
        <TopBar></TopBar>
        <SideMenu></SideMenu>
        <div class="container mx-auto page">
            <div class="grid grid-cols-1 sm:grid-cols-3 sm:gap-7 pt-4">
                <div>
                    <img class="w-full" src="https://devstoragebuzzebees.blob.core.windows.net/campaigns/104703_283140-large?time=0">
                </div>
                <div class="col-span-2 p-5 sm:p-0">
                    <div class="text-lg font-bold text-taro-yellow-1">ทาโร ปลาเส้น รสบาร์บีคิว 64 กรัม</div>
                    <div class="text-gray-500">ราคา 20 บาท</div>
                    <div>
                        <button class="bg-blue-700 text-xl font-bold text-white py-1 px-5 rounded-xl"
                                @click="clickRedeem()">Redeem</button>
                    </div>
                    <div class="flex mt-6 mb-7 text-white text-md ">
                        <div class="bg-gray-400 px-5 py-1 rounded-full cursor-pointer mr-3 "
                             :class="{'bg-gray-400' : tabActive != 'detail', 'bg-red-500' : tabActive == 'detail'}"
                             @click="clickTab('detail')">Detail</div>
                        <div class="bg-gray-400 px-5 py-1 rounded-full cursor-pointer "
                             :class="tabActive == 'condition' ? 'bg-red-500' : 'bg-gray-400'"
                             @click="clickTab('condition')">Condition</div>
                    </div>

                    <div v-show="tabActive == 'detail'">
                        ทาโร แบรนด์ขนมขบเคี้ยวที่ทำจากปลาอันดับหนึ่งของประเทศ

                        ทาโร อร่อย มีประโยชน์มากกว่าที่คิด
                        1. Protein ทาโรมีโปรตีนช่วยให้ร่างกายแข็งแรง มว้ากกกกก
                        2. Omega ทาโรมีโอเมก้า 3,6,9 ช่วยบำรุงสมอง ทำให้ความจำดี
                        3. DHA ทาโรมีดีเอชเอช่วยสลายความเครียด ควบคุมสติ แถมยังช่วยบำรุงประสาท ไม่ให้เราเป็นมนุษย์ขี้ลืมด้วยนะ
                        4. Collagen ทาโรมีคอลลาเจนช่วยให้คุณดูดีได้ตลอดทั้งวัน

                        ย้ำอีกครั้ง ทาโร ไม่มีไขมัน #Taronofat

                        หิว แต่กลัวอ้วน! นึกถึงเพื่อนอย่างทาโรสิคะ เพราะทาโรไม่มีไขมัน สะดวกพกพาง่าย แถมได้ประโยชน์สุดๆด้วย
                        รู้อย่างนี้แล้วจะรออะไรล้าาาาา จัดไปชุดใหญ่ไฟกระพริบ คลิ้กสั่งเล้ย! !
                    </div>
                    <div v-show="tabActive == 'condition'">
                        เงื่อนไข
                        1. สงวนสิทธิ์ให้เฉพาะสมาชิก ทาโร เท่านั้น
                        2. จำกัดเวลาในการรับสิทธิ์เฉพาะวันนี้ – 31 มกราคม 2564 เท่านั้น
                        3. สินค้าจะ "เริ่ม" ถูกจัดส่งภายใน 3 วันทำการ หลังการสั่งซื้อเสร็จสมบูรณ์ และจะถึงมือท่านภายใน 3 - 7 วันทำการ
                        4. กรณีที่สินค้าชำรุดเสียหายอันสืบเนื่องมาจากความผิดพลาดของบริษัทฯ สามารถคืนสินค้าได้ภายใน 7 วัน โดยอิงจากสถานะเลขพัสดุเท่านั้น (รวมวันเสาร์ อาทิตย์ และวันหยุดนักขัตฤกษ์) โดยสินค้าจะต้องครบถ้วนสมบูรณ์ บริษัทฯ จะทำการคืนค่าจัดส่งให้หลังจากตรวจสอบสินค้าเป็นที่เรียบร้อยแล้ว
                        5. บริษัทฯ ขอสงวนสิทธิ์การแก้ไขหรือเปลี่ยนแปลงเงื่อนไขต่าง ๆ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า
                        6. การจัดจำหน่ายผลิตภัณฑ์ทาโร บนแอปพลิเคชั่นนี้ ดำเนินการโดย บริษัท บัซซี่บีส์ จำกัด หากท่านมีข้อสงสัยหรือต้องการสอบถามเกี่ยวกับการจัดซื้อ และจัดส่งสินค้า กรุณาติดต่อบริษัท บัซซี่บีส์ จำกัด โทร. 02-649-0014
                    </div>
                </div>
            </div>
        </div>

        <!-- <ConfirmModal ref="modal-confirm" @onClickOk="clickConfirmRedeem()"></ConfirmModal>
        <SerialModal ref="modal-serial" @onTextCopy="onSerialModalCopyText()"></SerialModal>
        <PopMessageModal ref="pop-message-modal"></PopMessageModal> -->

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
import TopBar from "@/components/Layout/TopBar/TopBar.vue";
import SideMenu from "@/components/Layout/SideMenu/SideMenu.vue";
import ModalMixin from "@/mixin/ModalMixin.js";
// import ConfirmModal from "@/components/Modal/ConfirmModal.vue";
// import SerialModal from "@/components/Modal/SerialModal.vue";
// import PopMessageModal from "@/components/Modal/PopMessageModal.vue";

export default {
    name: "Detail",
    mixins: [ModalMixin],
    components: {
        TopBar,
        SideMenu,
        // ConfirmModal,
        // SerialModal,
        // PopMessageModal,
    },
    data: function() {
        return {
            tabActive: "detail", // detail, condition
        };
    },
    computed: {
        btnDetailColor: function() {
            return "sdds sdsd sd sd";
        },
    },
    methods: {
        clickTab: function(active) {
            this.tabActive = active;
        },
        clickRedeem: function() {
            // this.$refs['modal-confirm'].show();
            this.confirmModal.clearModal()
                .setTitle("Redeem")
                .setMsg("Confirm Redeem?")
                .setBtnOk("Redeem")
                .setBtnCancel("Cancel")
                .show();
        },
        clickConfirmRedeem: function() {
            console.log('confirm');
            this.$refs['modal-serial'].show();
        },

        onSerialModalCopyText: function() {
            console.log('click copy');
            this.$refs['pop-message-modal'].show();
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
